import React, { useCallback, useEffect } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from '../../../styles'
import { ButtonBase } from '@material-ui/core'
import Icon from '../../../components/icon/Icon'
import makeStyles from '@material-ui/core/styles/makeStyles'
import classNames from 'classnames'
import Question from './Question'
import { ModelQuestion, ModelTheme } from '../../../types/faq/faq_model'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import iconsEnum from '../../../enums/iconsEnum'
import { useMediaQuery } from 'react-responsive'

const ICON_PLUS: string = iconsEnum.Plus
const ICON_MINUS: string = iconsEnum.Minus
const GREY_BUTTON: string = 'greyButton'
const GREEN_BUTTON: string = 'greenButton'

const Accordion = withStyles((theme) => ({
	root: {
		borderTop: `1px solid ${theme.palette.blue['10']}`,
		boxShadow: 'none',
		marginBottom: 40,
		'&$expanded': {
			borderTop: `1px solid ${theme.palette.blue.main}`,
			margin: '0px 0px 40px 0px'
		}
	},
	expanded: {}
}))(MuiAccordion)

const AccordionSummary = withStyles((theme) => ({
	root: {
		padding: 0,
		'&$expanded': {
			minHeight: 0
		}
	},
	content: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		margin: '20px 0px 20px 0px',
		'&$expanded': {
			margin: '20px 0px 20px 0px'
		},
		'& #greyButton': {
			backgroundColor: theme.palette.blue['10'],
			'& svg': {
				fill: theme.palette.blue.main
			}
		},
		'& #greenButton': {
			backgroundColor: theme.palette.accessibility.main,
			'& svg': {
				fill: 'white'
			}
		}
	},
	expanded: {}
}))(MuiAccordionSummary)

const AccordionDetails = withStyles({
	root: {
		padding: 0,
		display: 'flex',
		flexDirection: 'column',
		'& :before': {
			display: 'none'
		}
	}
})(MuiAccordionDetails)

const useStyle = makeStyles((theme) => ({
		...styles(theme),
		button: {
			width: 40,
			height: 40,
			borderRadius: 40
		},
		themeText: {
			color: theme.palette.blue.main
		},
		iconAdd: {
			fill: theme.palette.blue.main
		}
	}
))

interface AcceptingProps {
	expandDefault: boolean
}

type ThemeProps =
	ModelTheme
	& AcceptingProps

const ThemeCompo: React.FC<ThemeProps> = (
	{
		name,
		questions,
		expandDefault
	}
) => {
	const [buttonClass, setButtonClass] = React.useState(GREY_BUTTON)
	const [icon, setIcon] = React.useState(ICON_PLUS)
	const [themeExpanded, setThemeExpanded] = React.useState(false)
	const classes = useStyle()

	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const themeTextClass = classNames(
		isLargeScreen ? [classes.title3] : [classes.title4],
		classes.themeText
	)

	const updateButton = (newClass: string, newIcon: string, newThemeExpand: boolean) => {
		setButtonClass(newClass)
		setThemeExpanded(newThemeExpand)
		setIcon(newIcon)
	}

	const updateExpand = useCallback(
		(expanded: boolean) => {
			if (expanded) {
				updateButton(GREEN_BUTTON, ICON_MINUS, expanded)
			} else {
				updateButton(GREY_BUTTON, ICON_PLUS, expanded)
			}
		}, []
	)

	useEffect(() => {
		updateExpand(expandDefault)
	}, [expandDefault, updateExpand])

	const handleExpand = () => {
		updateExpand(!themeExpanded)
	}

	return (
		<Accordion
			expanded={themeExpanded}
			onChange={handleExpand}
		>
			<AccordionSummary>
                    <span className={themeTextClass}>
                        {name}
                    </span>
				<ButtonBase id={buttonClass} className={classes.button}>
					<Icon icon={icon} size={12} className={classes.iconAdd} />
				</ButtonBase>
			</AccordionSummary>
			<AccordionDetails>
				{
					questions.map(
						(question: ModelQuestion, key) =>
							<Question
								key={key}
								keyword={question.keyword}
								question={question.question}
								response={question.response}
								parentExpanded={themeExpanded}
							/>
					)
				}
			</AccordionDetails>
		</Accordion>
	)
}
export default ThemeCompo
